// VERSION 1.0.0
// AUTHOR: AGALYA

import { docodeHexResponse } from '../../_common/common.utils';
import TransferCenterActionTypes from './transfer-center.types';

const INITIAL_STATE = {
	// TRANSFER LOG
	createTransferLogResponse: null,

	// MEMBER CENTER TRANSFER
	createCenterTransferResponse: null,

	// FETCH TRANSFER CENTER
	fetchTransferCenterDeatilsResponse: null,
	fetchTransferCenterDeatilsArr: [],

	// FETCH TRANSFER GROUP
	fetchTransferGroupDeatilsResponse: null,
	fetchTransferGroupDeatilsArr: [],
};

const transferCenterReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** CREATE TRANSFER LOG START  ******************/
		case TransferCenterActionTypes.CREATE_TRANSFER_LOG_SUCCESS:
			return {
				...state,
				createTransferLogResponse: action.payload,
			};

		case TransferCenterActionTypes.CREATE_TRANSFER_LOG_FAILURE:
			return {
				...state,
				createTransferLogResponse: action.payload,
			};

		case TransferCenterActionTypes.CREATE_TRANSFER_LOG_RESPONSE_CHANGED:
			return { ...state, createTransferLogResponse: null };

		/*************** CREATE TRANSFER LOG END  ******************/

		/*************** MEMBER CENTER TRANSFER START  ******************/
		case TransferCenterActionTypes.CREATE_CENTER_TRANSFER_SUCCESS:
			return {
				...state,
				createCenterTransferResponse: action.payload,
			};

		case TransferCenterActionTypes.CREATE_CENTER_TRANSFER_FAILURE:
			return {
				...state,
				createCenterTransferResponse: action.payload,
			};

		case TransferCenterActionTypes.CREATE_CENTER_TRANSFER_RESPONSE_CHANGED:
			return { ...state, createCenterTransferResponse: null };

		/*************** MEMBER CENTER TRANSFER END  ******************/

		/*************** FETCH TRANSFER CENTER START  ******************/
		case TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_SUCCESS:
			return {
				...state,
				fetchTransferCenterDeatilsResponse: action.payload,
				fetchTransferCenterDeatilsArr: docodeHexResponse(
					action.payload,
					'FetchParticularTransferCenterKey',
				),
			};

		case TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_FAILURE:
			return {
				...state,
				fetchTransferCenterDeatilsResponse: action.payload,
				fetchTransferCenterDeatilsArr: [],
			};

		case TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchTransferCenterDeatilsResponse: null };

		/*************** FETCH TRANSFER CENTER END  ******************/

		/*************** FETCH TRANSFER GROUP START  ******************/
		case TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_SUCCESS:
			return {
				...state,
				fetchTransferGroupDeatilsResponse: action.payload,
				fetchTransferGroupDeatilsArr: docodeHexResponse(
					action.payload,
					'GetAllGroupsListkey',
				),
			};

		case TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_FAILURE:
			return {
				...state,
				fetchTransferGroupDeatilsResponse: action.payload,
				fetchTransferGroupDeatilsArr: [],
			};

		case TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchTransferGroupDeatilsResponse: null };

		/*************** FETCH TRANSFER GROUP END  ******************/
		default:
			return state;
	}
};
export default transferCenterReducer;
